import React from 'react'
import { ErrorBoundaryMessage } from './error-boundary-message'

export interface ErrorBoundaryProps {
  readonly children: JSX.Element
  readonly renderCustomErrorView?: (props: {
    readonly DefaultErrorMessageView: () => JSX.Element
  }) => JSX.Element
}

interface ErrorBoundaryState {
  readonly error?: Error
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public static getDerivedStateFromError(error: Error) {
    return { error }
  }

  public state: ErrorBoundaryState = { error: undefined }

  public constructor(props: ErrorBoundaryProps) {
    super(props)
    this.resetComponent = this.resetComponent.bind(this)
  }

  public componentDidCatch(error: Error) {
    logError(error)
  }

  public render() {
    const { children, renderCustomErrorView } = this.props
    const { error } = this.state

    if (error) {
      // eslint-disable-next-line unicorn/prefer-ternary
      if (renderCustomErrorView) {
        return renderCustomErrorView({
          DefaultErrorMessageView: ErrorBoundaryMessage
        })
      } else {
        return <ErrorBoundaryMessage />
      }
    }

    return children
  }

  private resetComponent() {
    this.setState({ error: undefined })
  }
}

function logError(error: Error) {
  console.error(error)
}
